/**
 * PreviewBinomSection — live preview summary + full Standard workspace.
 *
 * For Media Devoted | Created By Ciro Autiero
 */

import { FC } from 'react';
import type { FlowOptimizerPreviewResult } from '@trafficpulse/shared';

import { PreviewIndexProvider } from '../components/preview/PreviewIndexContext';
import PreviewSummary from '../components/preview/PreviewSummary';
import BinomStandardConfigTabImpl from './standard/binom/BinomStandardConfigTabImpl';

export interface PreviewBinomSectionProps {
  result: FlowOptimizerPreviewResult;
  applied: boolean;
  killSwitch: boolean;
}

const PreviewBinomSection: FC<PreviewBinomSectionProps> = ({
  result,
  applied,
  killSwitch,
}) => (
  <PreviewIndexProvider
    items={result.items}
    countryKey={result.countryKey}
    campaignId={result.campaignId}
    provider={result.provider}
  >
    <div className="flex min-h-0 flex-1 flex-col gap-2 overflow-hidden">
      <PreviewSummary result={result} applied={applied} />
      <BinomStandardConfigTabImpl killSwitch={killSwitch} />
    </div>
  </PreviewIndexProvider>
);

export default PreviewBinomSection;
